import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { runInAction, action } from 'mobx';
import { Store } from 'libx';
import Notification from './Notification';
import InfiniteScrollProvider from '../data/InfiniteScrollProvider';
import { NotificationAPI } from './API';
import env from '../misc/env';
var NotificationStore = /*#__PURE__*/function (_Store) {
  function NotificationStore() {
    var _this;
    _classCallCheck(this, NotificationStore);
    _this = _callSuper(this, NotificationStore, arguments);
    _this.notifications = _this.collection({
      model: Notification
    });
    _this.notificationAPI = new NotificationAPI({
      baseURL: env.NOTIFICATION_API,
      getToken: _this.rootStore.authStore.getToken
    });
    _this.rootStore.authStore.onLogin(function () {
      _this.notificationAPI.subscribe("NotificationUpdated", _this.notifications.set);
    });
    _this.notificationsScrollProviders = new Map();
    return _this;
  }
  _inherits(NotificationStore, _Store);
  return _createClass(NotificationStore, [{
    key: "getScrollProviderForWorkspace",
    value: function getScrollProviderForWorkspace(workspaceId) {
      var _this2 = this;
      if (!this.notificationsScrollProviders.has(workspaceId)) {
        this.notificationsScrollProviders.set(workspaceId, new InfiniteScrollProvider({
          memoizeInitial: true,
          limit: 100,
          fetchItems: function fetchItems(params) {
            return _this2.fetch(_objectSpread(_objectSpread({}, params), {}, {
              workspace_id: workspaceId
            }));
          }
        }));
        this.notificationsScrollProviders.get(workspaceId).fetch();
      }
      return this.notificationsScrollProviders.get(workspaceId);
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var _this3 = this;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.notificationAPI.find(params).then(function (result) {
                var data = result.data;
                return _objectSpread(_objectSpread({}, result), {}, {
                  data: _this3.notifications.set(data)
                });
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "markAsRead",
    value: function () {
      var _markAsRead = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var notification, prev;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              notification = this.notifications.get(id);
              if (notification) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              if (!(notification.status === 'Read')) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              prev = notification.status;
              notification.set({
                status: 'Read'
              });
              _context2.next = 9;
              return this.rootStore.notificationStore.changeStatus({
                id: notification.id,
                status: 'Read'
              }).catch(function (err) {
                notification.set({
                  status: prev
                });
                throw err;
              });
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function markAsRead(_x2) {
        return _markAsRead.apply(this, arguments);
      }
      return markAsRead;
    }()
  }, {
    key: "changeStatus",
    value: function () {
      var _changeStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref) {
        var id, status;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              id = _ref.id, status = _ref.status;
              return _context3.abrupt("return", this.notificationAPI.changeStatus(id, {
                status: status
              }).then(this.notifications.set));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function changeStatus(_x3) {
        return _changeStatus.apply(this, arguments);
      }
      return changeStatus;
    }()
  }, {
    key: "markAllAsRead",
    value: function () {
      var _markAllAsRead = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
        var _this4 = this;
        var workspaceId, toMark, prev;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              workspaceId = params.workspaceId;
              toMark = this.notifications.filter(function (x) {
                return x.status !== 'Read' && x.workspaceId === workspaceId;
              });
              prev = toMark.map(function (n) {
                return [n.id, n.status];
              });
              runInAction(function () {
                toMark.forEach(function (n) {
                  n.set({
                    status: 'Read'
                  });
                });
              });
              return _context4.abrupt("return", this.notificationAPI.changeStatusBulk(toMark.map(function (x) {
                return {
                  id: x.id,
                  status: 'Read'
                };
              })).then(this.notifications.set).catch(
              // Restores status if it failed.
              action(function (err) {
                prev.forEach(function (_ref2) {
                  var _ref3 = _slicedToArray(_ref2, 2),
                    id = _ref3[0],
                    status = _ref3[1];
                  _this4.notification.get(id).set({
                    status: status
                  });
                });
                throw err;
              })));
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function markAllAsRead(_x4) {
        return _markAllAsRead.apply(this, arguments);
      }
      return markAllAsRead;
    }()
  }]);
}(Store);
export { NotificationStore as default };
//# sourceMappingURL=NotificationStore.js.map
